export default __webpack_public_path__ + "static/media/plumbing.bad9c13c.jpg";